module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("© 2012 The Johns Hopkins University Press"), _c('br'), _vm._v("All rights reserved. Published 2012"), _c('br'), _vm._v("Printed in the United States of America on acid-free paper"), _c('br'), _vm._v("9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Johns Hopkins University Press"), _c('br'), _vm._v("2715 North Charles Street"), _c('br'), _vm._v("Baltimore, Maryland 21218-4363"), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.press.jhu.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.press.jhu.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Prescribed : writing, filling, using, and abusing the prescription in modern"), _c('br'), _vm._v("America / edited by Jeremy A. Greene and Elizabeth Siegel Watkins."), _c('br'), _vm._v("       p. ; cm."), _c('br'), _vm._v("  Includes bibliographical references and index."), _c('br'), _vm._v("  ISBN-13: 978-1-4214-0506-3 (hdbk. : alk. paper)"), _c('br'), _vm._v("  ISBN-13: 978-1-4214-0507-0 (pbk. : alk. paper)"), _c('br'), _vm._v("  ISBN-10: 1-4214-0506-7 (hdbk. : alk. paper)"), _c('br'), _vm._v("  ISBN-10: 1-4214-0507-5 (pbk. : alk. paper)"), _c('br'), _vm._v("  I. Greene, Jeremy A., 1974- II. Watkins, Elizabeth Siegel."), _c('br'), _vm._v("  [DNLM: 1. Prescriptions—history—United States. 2. Government"), _c('br'), _vm._v("Regulation—history—United States. 3. History, 20th Century—United"), _c('br'), _vm._v("States. 4. Professional Autonomy—United States. 5. Substance-Related"), _c('br'), _vm._v("Disorders—history—United States. QV 11 AA1]"), _c('br'), _vm._v("  LC classification not assigned"), _c('br'), _vm._v("  615.1’4—dc23                                         2011029814")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Special discounts are available for bulk purchases of this book. For"), _c('br'), _vm._v("more information, please contact Special Sales at 410-516-6936 or")]), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "mailto:specialsales@press.jhu.edu"
    }
  }, [_c('em', [_vm._v("specialsales@press.jhu.edu")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Johns Hopkins University Press uses environmentally friendly"), _c('br'), _vm._v("book materials, including recycled text paper that is composed of at least"), _c('br'), _vm._v("30 percent post-consumer waste, whenever possible.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad2c05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 66
// module chunks = 0